import { render, staticRenderFns } from "./materialCheckDetail.vue?vue&type=template&id=3ff63ae6"
import script from "./materialCheckDetail.vue?vue&type=script&lang=js"
export * from "./materialCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports